import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { ToastActions } from '../state/toast/toast.actions';
import { BLService } from './bl.service';
import {
  OnboardCompanyWithAnnualClientCollaborationPackageBody,
  OnboardCompanyWithAnnualClientCollaborationPackageResponse,
  OnboardExistingClientBody,
  OnboardingExtraClientInfo,
  OnboardingResponse,
} from './onboarding.service.types';

@Injectable({ providedIn: 'root' })
export class OnboardingService extends BLService {
  private RESOURCE_ENDPOINT = 'onboarding';

  constructor() {
    super();
    this.useTranslation('OnboardingService');
  }

  getOnboardingKey(
    clientId: number,
    body: OnboardExistingClientBody,
    loadRemoteVatIntervalInformation = false,
  ): Observable<string> {
    return this.httpPost<OnboardingResponse>(
      `${this.RESOURCE_ENDPOINT}/${clientId}?loadRemoteVatIntervalInformation=${loadRemoteVatIntervalInformation}`,
      body,
      undefined,
      (source) =>
        source.pipe(
          catchError((err: unknown) => {
            this.dispatchOnboardingError();
            return throwError(() => err);
          }),
          this.catchErrorAndShowMessage(),
        ),
    ).pipe(map((response: OnboardingResponse) => response.key));
  }

  getOnboardingKeyForNonExistingClient(
    body: OnboardingExtraClientInfo,
    loadRemoteVatIntervalInformation = false,
  ): Observable<string> {
    return this.httpPost<OnboardingResponse>(
      `${this.RESOURCE_ENDPOINT}?loadRemoteVatIntervalInformation=${loadRemoteVatIntervalInformation}`,
      { client: body },
    ).pipe(map((response: OnboardingResponse) => response.key));
  }

  onboardCompanyWithAnnualClientCollaborationPackage(
    body: OnboardCompanyWithAnnualClientCollaborationPackageBody,
  ): Observable<OnboardCompanyWithAnnualClientCollaborationPackageResponse> {
    return this.httpPost<OnboardCompanyWithAnnualClientCollaborationPackageResponse>(
      `${this.RESOURCE_ENDPOINT}/company/with-annual-client`,
      body,
    );
  }

  private dispatchOnboardingError(): void {
    this.store.dispatch(
      ToastActions.showErrorMessage({
        summary: this.translate('anErrorOccured'),
        detail: this.translate('failedToFetchClientInformation'),
      }),
    );
  }
}
